module.exports = __webpack_public_path__ + "assets/icons/ic_crop_free-c134.svg";